import { EventSequencerActionPayloadType } from './eventSequencer.types';

export const NOOP_PAYLOAD: EventSequencerActionPayloadType = {
  events: [],
  selector: ({ formCreator }) => formCreator,
};
